import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { GET_MORTGAGE_CLIENTS, GET_ACTIVITY_CLIENTS, GET_BIRTHDAY_CLIENTS } from "../store/dashboard-getters";
import { LOAD_MORTGAGES, LOAD_ACTIVITIES, LOAD_BIRTHDAYS } from "../store/dashboard-actions";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InformationalCard",
  props: {
    infoType: {
      type: String,
      required: true
    },
    infoText: {
      type: String,
      required: true
    },
    numberOfDays: {
      type: [String, Number],
      required: true
    },
    past: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("DashboardStore", [GET_MORTGAGE_CLIENTS, GET_ACTIVITY_CLIENTS, GET_BIRTHDAY_CLIENTS])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), {}, {
    informationalDescription() {
      return `<span>${this.infoText}</span> ${this.centerText}`;
    },
    dataCount() {
      switch (this.infoType) {
        case "Mortgage":
          return this.GET_MORTGAGE_CLIENTS.length;
        case "Activity":
          return this.GET_ACTIVITY_CLIENTS.length;
        case "Birthday":
          return this.GET_BIRTHDAY_CLIENTS.length;
        default:
          return 0;
      }
    },
    centerText() {
      return this.past ? this.$t("dashboard.informationalCards.expiredInThePastDays", {
        days: this.numberOfDays
      }) : this.$t("dashboard.informationalCards.inTheNextDays", {
        days: this.numberOfDays
      });
    },
    agentUsername() {
      return this.CURRENT_USER_USERNAME;
    }
  }),
  async mounted() {
    switch (this.infoType) {
      case "Mortgage":
        try {
          await this.LOAD_MORTGAGES({
            agentUsername: this.agentUsername,
            days: this.numberOfDays
          });
        } finally {
          this.$emit("loaded");
        }
        break;
      case "Activity":
        await this.LOAD_ACTIVITIES({
          days: this.numberOfDays,
          expired: false
        });
        break;
      case "Birthday":
        await this.LOAD_BIRTHDAYS({
          agentUsername: this.agentUsername,
          days: this.numberOfDays
        });
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DashboardStore", [LOAD_MORTGAGES, LOAD_ACTIVITIES, LOAD_BIRTHDAYS])), {}, {
    handleClick() {
      this.$emit("click");
    }
  })
});